// How many messages to fetch initially when opening a chat
export const initialMessageCount = 20
